import {
  Divider,
  Drawer as DrawerWrapper,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  FlexProps,
} from "@chakra-ui/react";
import { ReactNode, useRef } from "react";

type DrawerProps = {
  children: ReactNode;
  isOpen: boolean;
  onClose: () => void;
  onOpen?: () => void;
  title?: string;
  titleColor?: string;
  titleBackground?: string;
  placement?: any;
  footerStyle?: FlexProps;
  footerChildren?: React.ReactNode;
};

export default function Drawer({
  title,
  titleColor = "blackAlpha.700",
  titleBackground,
  children,
  isOpen,
  onClose,
  placement = "right",
  footerStyle,
  footerChildren,
}: DrawerProps) {
  const btnRef = useRef(null);

  if (!isOpen) return null;

  return (
    <DrawerWrapper
      isOpen={isOpen}
      placement={placement}
      onClose={onClose}
      finalFocusRef={btnRef}
      size="xs"
    >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton color={titleColor} />
        <DrawerHeader bg={titleBackground} color={titleColor}>
          {title}
        </DrawerHeader>

        <Divider />

        <DrawerBody>{children}</DrawerBody>

        {footerChildren && (
          <DrawerFooter {...footerStyle}>{footerChildren}</DrawerFooter>
        )}
      </DrawerContent>
    </DrawerWrapper>
  );
}
